var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.173 10.92V14.2H20.013C19.773 16.04 19.16 17.387 18.226 18.333C17.079 19.48 15.293 20.733 12.173 20.733C7.346 20.733 3.573 16.84 3.573 12.013C3.573 7.186 7.346 3.293 12.173 3.293C14.773 3.293 16.68 4.32 18.08 5.64L20.387 3.333C18.44 1.44 15.826 0 12.173 0C5.56 0 0 5.387 0 12C0 18.613 5.56 24 12.173 24C15.746 24 18.44 22.827 20.546 20.64C22.706 18.48 23.386 15.427 23.386 12.973C23.386 12.213 23.333 11.506 23.213 10.92H12.173Z",
    fill: "#403194"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f46ab00c2ff69d88574b95eaf3b486f3.svg";
export { ForwardRef as ReactComponent };